















































import { createComponent, provide, computed } from "@vue/composition-api";
import { sheetOptionsSymbol } from "@/components/sheet/SheetEntries";
import { DecisionChange } from "@megarax/client/src/resources/Decision";
import router from "@/router";
import ResourceItemHyperlink from "@/components/resource/ResourceItemHyperlink";
import { useActions } from "@/shared/useMegaraxClient";
import { Resource } from "@megarax/client/src";
import { getResourceModule } from "@/apps/apps";
import { AppModule, ResourceAppModule } from "@/shared/app";
import { getResourceModulePath, getModulePath } from "@/apps/getPath";
import { ResourceIdentifier } from "@megarax/client/src/resources/Resource";

interface Props {
  value: DecisionChange<any>;
  revisionModule: ResourceAppModule;
}

export default createComponent<Props>({
  components: { ResourceItemHyperlink },
  name: "DecisionChangeCard",
  props: {
    value: {
      required: true,
    },
    revisionModule: {
      required: true,
    },
  },
  setup(props, ctx) {
    const resourceActions = useActions(props.revisionModule.resource);

    async function duplicate() {
      const duplicated = await resourceActions.duplicateItem(props.value.new);
      ctx.root.$notify.success("Utworzono kopię roboczą");
      router.push(getModulePath(props.revisionModule, duplicated.id!));
    }

    const diff = props.value.previous
      ? props.value.new.getDiff(props.value.previous) || {}
      : {};

    provide(sheetOptionsSymbol, diff);

    return {
      duplicate,
      diff,
      revisionSheetComponent: props.revisionModule.sheetComponent,
    };
  },
});
